import React, { useState, useEffect } from "react";

import "./SelectWithInnerLabel.scss";

import { useTranslation } from "react-i18next";

const SelectWithInnerLabel = ({
  stateValue,
  setStateValue,
  labelText,
  idText,
  options,
  redBorder = false,
  disabled = false,
  locale = false,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const getOptionName = (option) => {
    let optionName = option?.Name;
    if (currentLanguage != "en") {
      const localization = option?.Locale?.data?.find(
        (local) => local?.attributes?.locale === currentLanguage
      );
      if (localization) {
        optionName = localization?.attributes?.Name;
      }
    }

    return optionName;
  };

  // <select> values always arrive as strings. Numeric ids are coerced back to
  // numbers so strict comparisons (e.g. `switch (country)`) and effect
  // dependencies stay stable. Empty and non-numeric values are preserved.
  const handleChange = (e) => {
    const rawValue = e.target.value;
    const isNumeric = rawValue.trim() !== "" && !Number.isNaN(Number(rawValue));
    setStateValue(isNumeric ? Number(rawValue) : rawValue);
  };

  return (
    <div className="select-inner-container">
      <select
        className="select-inner"
        id={`select-inner-${idText}`}
        value={stateValue}
        onChange={handleChange}
        style={{
          border: `1px solid ${
            redBorder && (options?.length === 0 || stateValue?.length === 0)
              ? "red"
              : "#00000040"
          }`,
        }}
        disabled={disabled}
      >
        {options?.length > 0 &&
          options?.map((option, index) => {
            return (
              <option key={index} value={option?.iso3 ?? option?.id}>
                {locale ? getOptionName(option) : option?.Name}
              </option>
            );
          })}
      </select>
      <label className="select-inner-label" htmlFor={`select-inner-${idText}`}>
        {labelText}
      </label>
    </div>
  );
};

export default SelectWithInnerLabel;
